import React, { useEffect, useRef } from 'react';
import OmnitureUtils from '../../../../../../../common/utils/Omniture/OmnitureUtils';
import { faOnPackageScroll } from './analytics-services';
import { getMMT_HLD_OBJ } from '../../../../../../../common/utils/appUtils';
import { modifyPdtData, modifySectionForPDT } from '../../../../pdtUtils';

const ScrollTracker = ({
  rowNumber,
  isLoading,
  groupId,
  sectionsLoading,
  fireEvent = true,
  prop54,
  prop1,
  activeTabData,
  sectionData,
  packageList,
}) => {
  const isTracked = useRef({});
  const scrollRef = useRef(null);

  const trackViewEvent = (currentRow, currentGroupId) => {
    // eslint-disable-next-line no-undef
    if (ssr.isOnClient && !(getMMT_HLD_OBJ().fromSEO && prop54.includes('Viewed_Section_'))) {
      // eslint-disable-next-line no-undef
      const rowObjStr = ssr.isOnClient ? window.localStorage.getItem('currentRow') : '';
      if (rowObjStr && window.scrollY > 0) {
        window.localStorage.setItem(
          'currentRow',
          JSON.stringify({
            currentRow,
            activeTab: { id: activeTabData?.id, name: activeTabData?.shortName },
          })
        );
      } else {
        window.localStorage.setItem(
          'currentRow',
          JSON.stringify({
            currentRow: 0,
            activeTab: { id: activeTabData?.id, name: activeTabData?.shortName },
          })
        );
      }
      if (!isTracked?.current?.[currentGroupId]) {
        isTracked.current = { ...isTracked?.current, [currentGroupId]: true };
        if (fireEvent) {
          faOnPackageScroll({ sectionCode: prop54, currentRow });
          OmnitureUtils.trackClickEvent({
            prop54: `${prop54}_${currentRow}`,
            prop1,
          });
        }
      }
      if (sectionData !== undefined) {
        const storedSections = JSON.parse(window.localStorage.getItem('storedSections')) || [];
        const isSectionStored = storedSections.some(
          storedSection =>
            JSON.stringify(storedSection) === JSON.stringify(modifySectionForPDT(sectionData))
        );
        if (!isSectionStored) {
          const modifiedSectionData = modifySectionForPDT(sectionData);
          storedSections.push(modifiedSectionData);
        }
        window.localStorage.setItem('storedSections', JSON.stringify(storedSections));
      }
      if (packageList !== undefined) {
        const storedPackages = JSON.parse(window.localStorage.getItem('storedPackages')) || [];
        packageList?.forEach(pack => {
          const isPackageStored = storedPackages.some(
            storedPackage => storedPackage.id === pack.id
          );
          if (!isPackageStored) {
            const [pack] = modifyPdtData([pack]);
            storedPackages.push(pack);
          }
        });
        window.localStorage.setItem('storedPackages', JSON.stringify(storedPackages));
      }
    }
  };

  useEffect(() => {
    if (!isLoading && scrollRef?.current && !sectionsLoading) {
      const observer = new IntersectionObserver((entry, observer) => {
        if (entry[0].isIntersecting) {
          trackViewEvent(rowNumber, groupId);
        }
      });
      observer.observe(scrollRef?.current);

      return () => {
        if (scrollRef?.current) {
          observer.unobserve(scrollRef?.current);
        }
      };
    }
  }, [rowNumber, isLoading, groupId, sectionsLoading]);

  return <div style={{ height: 0, width: '100%' }} ref={scrollRef} />;
};

export default ScrollTracker;
